import { useEffect, useState } from "react";

// Reusable for any client/content type: useContent("bbi", "devotionals").
// Fetches the public list from the content API and keeps it for 30 seconds,
// so moving between pages doesn't re-download it every time.
const API_URL = (process.env.REACT_APP_CONTENT_API_URL || "").replace(/\/$/, "");
const CACHE_MS = 30 * 1000;
const cache = new Map(); // "client/type" -> { time, promise }

function fetchEntries(client, type) {
  const key = `${client}/${type}`;
  const hit = cache.get(key);
  if (hit && Date.now() - hit.time < CACHE_MS) return hit.promise;

  const promise = fetch(`${API_URL}/content/${client}/${type}`)
    .then((res) => {
      if (!res.ok) throw new Error(`Request failed (${res.status})`);
      return res.json();
    })
    .then((data) => {
      if (!data || !Array.isArray(data.items)) throw new Error("Unexpected reply");
      return data.items;
    })
    .catch((err) => {
      cache.delete(key); // don't remember failures
      throw err;
    });

  cache.set(key, { time: Date.now(), promise });
  return promise;
}

export function useContent(client, type) {
  const [state, setState] = useState({ entries: [], loading: true, error: "" });

  useEffect(() => {
    let cancelled = false;
    fetchEntries(client, type)
      .then((entries) => {
        if (!cancelled) setState({ entries, loading: false, error: "" });
      })
      .catch(() => {
        if (!cancelled)
          setState({
            entries: [],
            loading: false,
            error: "We couldn't load this right now. Please refresh the page or try again shortly.",
          });
      });
    return () => {
      cancelled = true;
    };
  }, [client, type]);

  return state;
}